module.exports = __webpack_public_path__ + "static/media/insurance.4f672e10.png";